import { Component, inject } from '@angular/core';
import {
  MatSnackBarAction,
  MatSnackBarActions,
  MatSnackBarLabel,
  MatSnackBarRef
} from '@angular/material/snack-bar';
import { ButtonComponent } from 'htx-ui-library';

@Component({
  selector: 'app-error-snackbar',
  templateUrl: 'error-snackbar.component.html',
  styleUrls: ['error-snackbar.component.scss'],
  imports: [ButtonComponent, MatSnackBarLabel, MatSnackBarActions, MatSnackBarAction]
})
export class ErrorSnackbarComponent {
  snackBarRef = inject(MatSnackBarRef);
}
